import { render, staticRenderFns } from "./CoozzyUserbaseFooter.vue?vue&type=template&id=e09934b6&scoped=true"
import script from "./CoozzyUserbaseFooter.vue?vue&type=script&lang=js"
export * from "./CoozzyUserbaseFooter.vue?vue&type=script&lang=js"
import style0 from "./CoozzyUserbaseFooter.vue?vue&type=style&index=0&id=e09934b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09934b6",
  null
  
)

export default component.exports